import { modelComposition } from 'trait/composition'

const descriptor = 'model::ticket::item'

export default modelComposition(descriptor)
